import { useCallback, useEffect, useState } from 'react';
import { Socket } from 'socket.io-client';

import {
  cleanupSocketV2ResearchAssistant,
  getSocketV2ResearchAssistant,
} from '@verantos-dev/app-state-base';

export const useResearchAssistantSocketInit = () => {
  const [socket, setSocket] = useState<Socket | undefined>();

  useEffect(() => {
    const initializeSocket = async () => {
      // RAG workflow remains available on the legacy socket namespace.
      const s = await getSocketV2ResearchAssistant('/agent');
      setSocket(s);
    };

    initializeSocket();

    return () => {
      console.info('[RA Socket Context] Cleaning up socket context');
      cleanupSocketV2ResearchAssistant();
      setSocket(undefined);
    };
  }, []);

  const cleanupSocket = useCallback(() => {
    socket?.disconnect();
  }, [socket]);

  return { socket, cleanupSocket };
};
